import client, { ApiResponse } from '../config/axiosConfig';

export const GetBlogPostDetail = async (url: string): Promise<ApiResponse> => await client.get(`blog-posts/${url}`);

export const GetBlogPosts = async (page: number, limit: number, filters: string): Promise<ApiResponse> => await client.get(`/blog-posts/${page}/${limit}?filters=${filters}`);

export const GetBlogPostsList = async (): Promise<ApiResponse> => await client.get('/blog-posts');
